import { Html } from "@custom/schema";
import React from "react";
export default function SidebarCta(props) {
    var _props_button, _props_button1;
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-gray-50 text-white block pt-7 pb-8 mb-8 md:mb-12 px-6 lg:px-8 relative bg-gray-angle img-flip overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "inline-block text-gray-50 bg-white rounded-full uppercase text-xxs tracking-wider font-semibold py-[4px] px-2.5 mb-4"
    }, props.badge), props.heading ? /*#__PURE__*/ React.createElement("h3", {
        className: "block text-lg md:text-2xl font-heading mb-5"
    }, props.heading) : null, props.description ? /*#__PURE__*/ React.createElement("p", {
        className: "mb-5 md:mb-7 block text-sm lg:text-base"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.description
    })) : null), /*#__PURE__*/ React.createElement("a", {
        href: "".concat((_props_button = props.button) === null || _props_button === void 0 ? void 0 : _props_button.target),
        className: "button-secondary relative bg-gray-50 border-white hover:bg-white hover:text-gray-600 focus-white"
    }, (_props_button1 = props.button) === null || _props_button1 === void 0 ? void 0 : _props_button1.label));
}
